import React from "react";
import clsx from "clsx";

import { useColorScheme } from "hooks/useColorScheme";
import { IOption } from "models/Form";
import styles from "./style.module.scss";

interface IProps {
  data: IOption[];
  isMulti?: boolean;
  setSelectedValue: React.Dispatch<React.SetStateAction<IOption>>;
}

export default function Switch({ data, isMulti = false, setSelectedValue }: Readonly<IProps>) {
  const { currentIsDark } = useColorScheme();
  const [filterType, setFilterType] = React.useState(data[0]);

  const handleClick = (item: IOption) => {
    setFilterType(item);
    setSelectedValue(item);
  };

  const getClassBtn = () => {
    switch (filterType) {
      case data[0]:
        return "translate-x-0 w-1/4";
      case data[1]:
        return "translate-x-12 w-1/4";
      case data[2]:
        return "translate-x-24 w-1/4";
      case data[3]:
        return "translate-x-36 w-1/4";
    }
  };

  const tabClass =
    filterType.value === data[0].value ? "translate-x-0 w-1/2" : "translate-x-full w-1/2";

  return (
    <ul className={clsx(styles.tabSwitchContainer, isMulti ? "w-48" : "w-28")}>
      {data.map((item) => (
        <li key={item.id} className={styles.tabItem}>
          <button
            aria-label={`${item.id}-${item.label}`}
            type="button"
            className={
              !currentIsDark
                ? filterType.value === item.value
                  ? "text-white"
                  : "text-black"
                : "text-text"
            }
            onClick={() => handleClick(item)}>
            {item.label}
          </button>
        </li>
      ))}
      <div className={clsx(styles.tabIndicator, isMulti ? getClassBtn() : tabClass)}></div>
    </ul>
  );
}
